import { isNonEmptyString } from "utils/string/is-non-empty-string";

export const joinUrl = (url: string, params: URLSearchParams): string => {
  const search = params.toString();

  return isNonEmptyString(search) ? `${url}?${search}` : url;
};
